import { Box } from "@mui/material";
import logoVert from "../../../../ressources/images/logo_vertuloo_vert.png";
import certification from "../../../../ressources/images/offre_certif.png";
import checkVert from "../../../../ressources/images/offre_check.png";
import styles from "./styles";

interface IProps {
  classes?: any;
}

const BlocOffres = (props: IProps) => {
  return (
    <Box className={"container"} sx={styles}>
      <img src={logoVert} width={100} alt="immobilier & construction" />
      <h2>Choisissez l'offre qui vous correspond</h2>
      <div className={"divider"} />
      <div className={"containerOffres"}>
        <div className={"offre"}>
          <div className={"titre"}>
            Offre <strong>Starter</strong>
          </div>

          <div className={"assureContainer assureStarter"}>
            <p>
              lot <br />
              <strong>assuré</strong>
            </p>
          </div>
          <div className={"containerTexte"}>
            <div>
              <p>
                <strong>
                  Contrôle automatisé de l’authenticité et de la conformité
                </strong>{" "}
                des pièces du dossier de candidature du locataire.
              </p>
              <div className={"images imageGrey"}>
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator grey"} />
            <div>
              <p>
                <strong>
                  Analyse pragmatique et sécurisée de la solvabilité des
                  candidats.
                </strong>
              </p>
              <div className={"images imageGrey"}>
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator grey"} />
            <div>
              <p>
                <strong>
                  Outil d’aide pour éclairer la prise de décision de
                  l’administrateur de biens.
                </strong>{" "}
              </p>
              <div className={"images imageGrey"}>
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator grey"} />
            <div>
              <p>
                <strong>
                  Certification assurance contre le risque de loyers impayés
                </strong>{" "}
                qui atteste de l’effectivité du contrat pour 100% des dossiers
                accepté
              </p>
              <div className={"images imageGrey"}>
                <img src={certification} width={50} height={48} alt="" />
              </div>
            </div>
          </div>
          <div className={"button buttonGrey"}>
            <div>
              <p>1,5€*</p>
              <span>par mois</span>
            </div>
          </div>
        </div>
        <div className={"offrePremium"}>
          <div className={"titrePremium"}>
            Offre <strong>Premium</strong>
          </div>
          <div className={"dividerDeux"}>
            <span>lot</span>
          </div>
          <div className={"assureContainer"}>
            <p>assuré</p>
            <p>
              non
              <br />
              assuré
            </p>
          </div>
          <div className={"containerTexte"}>
            <div>
              <p>
                <strong>
                  Contrôle automatisé de l’authenticité et de la conformité
                </strong>{" "}
                des pièces du dossier de candidature du locataire.
              </p>
              <div className={"images"}>
                <img src={checkVert} width={30} height={30} alt="" />
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator"} />
            <div>
              <p>
                <strong>
                  Analyse pragmatique et sécurisée de la solvabilité des
                  candidats.
                </strong>
              </p>
              <div className={"images"}>
                <img src={checkVert} width={30} height={30} alt="" />
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator"} />
            <div>
              <p>
                <strong>
                  Outil d’aide pour éclairer la prise de décision de
                  l’administrateur de biens.
                </strong>{" "}
              </p>
              <div className={"images"}>
                <img src={checkVert} width={30} height={30} alt="" />
                <img src={checkVert} width={30} height={30} alt="" />
              </div>
            </div>
            <div className={"separator"} />
            <div>
              <p>
                <strong>
                  Certification assurance contre le risque de loyers impayés
                </strong>{" "}
                qui atteste de l’effectivité du contrat pour 100% des dossiers
                accepté
              </p>
              <div className={"images"}>
                <img src={certification} width={50} height={48} alt="" />
                <div />
              </div>
            </div>
            <div className={"separatorVertical"} />
          </div>
          <div className={"button"}>
            <div>
              <p>1,5€*</p>
              <span>par mois</span>
            </div>
            <div>
              <p>offert**</p>
            </div>
          </div>
        </div>
      </div>
      <p>* intégré à l'assurance pour un lot quittancé à 600€/mois</p>
      <p>** offert si + de 75% des lots sont assurés en GLI</p>
    </Box>
  );
};

export default BlocOffres;
